import { ExternalLink, GitPullRequestCreateArrow } from 'lucide-react'
import { Typography } from '~/components/common/Typography'
import { cm } from '~/utils'

interface PullRequestResultProps {
  prLink: string
  className?: string
}

export default function PullRequestResult({ prLink, className }: PullRequestResultProps) {
  const href = prLink.trim()
  if (!href) return null

  return (
    <section
      className={cm(
        'flex w-full items-center gap-3 rounded-[16px] border border-tokens-neutral-border-2 bg-tokens-neutral-bg-white px-4 py-3 shadow-sm',
        className
      )}
    >
      <div className='flex size-10 shrink-0 items-center justify-center rounded-[12px] bg-[var(--status-link-base,rgba(132,111,225,0.10))] text-tokens-neutral-bg-action'>
        <GitPullRequestCreateArrow className='size-5' />
      </div>
      <div className='flex min-w-0 flex-1 items-center justify-between gap-4'>
        <div className='min-w-0 flex-1'>
          <Typography
            fontFamily='geist'
            fontSize='bodyMdMedium'
            fontWeight='semibold'
            className='text-tokens-neutral-text-primary'
          >
            Pull request ready
          </Typography>
          <Typography
            fontFamily='geist'
            fontSize='bodySm'
            className='mt-0.5 text-tokens-neutral-text-secondary'
          >
            The approved changes were pushed to a pull request.
          </Typography>
        </div>
        <a
          href={href}
          target='_blank'
          rel='noopener noreferrer'
          className='inline-flex h-9 shrink-0 items-center gap-2 rounded-[16px] bg-[var(--neutral-fill-Fill-2,rgba(0,0,0,0.02))] px-3 text-sm font-semibold text-tokens-neutral-bg-action transition-colors hover:bg-[var(--status-link-base,rgba(132,111,225,0.10))]'
        >
          View PR
          <ExternalLink className='size-4' />
        </a>
      </div>
    </section>
  )
}
